export const translations = {
  en: {
    nav: {
      home: "Home",
      about: "About",
      projects: "Projects",
      resume: "Resume",
    },
    home: {
      greeting: "Hi There!",
      iam: "I'M",
    },
    home2: {
      letMe: "LET ME",
      introduce: "INTRODUCE",
      myself: "MYSELF",
      intro:
        "I'm a Full Stack Developer specialized in end-to-end web and mobile solutions.",
      approach:
        "I follow projects end-to-end, from requirements analysis to architectural design, through development, deployment and infrastructure management.",
      stack: [
        "Angular",
        "React/Next.js",
        "Flutter",
        ".NET",
        "Java",
        "Node.js",
        "Docker",
        "Kubernetes",
      ],
      philosophy:
        "I like to understand the problem before choosing how to solve it, working in a practical way and aiming to keep code simple, clear and easy to evolve.",
      findMeOn: "FIND ME ON",
      feelFree: "Feel free to",
      connect: "connect",
      withMe: "with me",
    },
    typeStrings: ["Software Developer"],
    about: {
      knowWho: "Know Who",
      iam: "I'M",
      professional: "Professional",
      skillset: "Skillset",
      tools: "Tools",
      iuse: "I use",
    },
    aboutCard: {
      bio: "I'm Matteo, I live in Chivasso (TO) and work as a software developer at BigoSolutions SRL.",
      extra: "Besides my daily work, I enjoy exploring new technologies, experimenting and developing personal projects to test new ideas and solutions.",
      hobbies: ["Travels", "Books", "Trekking and Triathlon"],
    },
    projects: {
      myRecent: "My Recent",
      works: "Works",
      subtitle: "Here are a few projects I've worked on recently.",
      visit: "Visit",
      items: [
        {
          title: "GocciaGo",
          description:
            "Mobile app to find public drinking water fountains near you.",
        },
        {
          title: "QuotaReader",
          description:
            "QuotaReader automatically extracts all dimensions from vector PDFs and numbers them with interactive callouts. From dimensioning to the FAI report without manually re-entering anything.",
        },
        {
          title: "App Mobile - Supabase API",
          description:
            "The project uses Supabase as a backend-as-a-service to provide authentication, database and serverless API functionality.",
        },
        {
          title: "Fullstack Kafka Application",
          description:
            "Full-stack application built with React, Node.js, Kafka and Docker.",
        },
        {
          title: "DocuChat — Local RAG Chatbot",
          description:
            "Chat with your PDF documents using a fully local AI infrastructure. No cloud, no API keys, no data ever leaves your computer.",
        },
        {
          title: "PDF Chatbot MVP",
          description:
            "PDF-based document chatbot. Lets you upload PDFs, ask questions, and verify answers against the original document sources. In this first version, responses are not generated by an LLM but mocked with default answers.",
        },
      ],
    },
    resume: {
      download: "Download CV",
    },
    presentation: {
      title: "Presentation",
      titleHighlight: "Video",
      subtitle: "Enter the password to watch the presentation video.",
      placeholder: "Password",
      submit: "Unlock",
      wrongPassword: "Incorrect password. Please try again.",
    },
  },

  it: {
    nav: {
      home: "Home",
      about: "Chi Sono",
      projects: "Progetti",
      resume: "Curriculum",
    },
    home: {
      greeting: "Ciao!",
      iam: "SONO",
    },
    home2: {
      letMe: "PERMETTIMI DI",
      introduce: "PRESENTARMI",
      myself: "",
      intro:
        "Sono un Full Stack Developer specializzato nello sviluppo di soluzioni web e mobile end-to-end.",
      approach:
        "Seguo i progetti a 360°, dall'analisi dei requisiti alla progettazione dell'architettura, dallo sviluppo fino al deploy e alla gestione dell'infrastruttura.",
      stack: [
        "Angular",
        "React/Next.js",
        "Flutter",
        ".NET",
        "Java",
        "Node.js",
        "Docker",
        "Kubernetes",
      ],
      philosophy:
        "Mi piace capire il problema prima di scegliere come risolverlo, lavorando in modo pratico e cercando di mantenere il codice semplice, chiaro e facile da evolvere.",
      findMeOn: "TROVAMI SU",
      feelFree: "Sentiti libero di",
      connect: "connetterti",
      withMe: "con me",
    },
    typeStrings: ["Sviluppatore Software"],
    about: {
      knowWho: "Scopri Chi",
      iam: "SONO",
      professional: "Competenze",
      skillset: "Tecniche",
      tools: "Strumenti",
      iuse: "che uso",
    },
    aboutCard: {
      bio: "Sono Matteo, vivo a Chivasso (TO) e lavoro come sviluppatore software presso BigoSolutions SRL.",
      extra: "Oltre al mio lavoro quotidiano, mi piace esplorare nuove tecnologie, sperimentare e sviluppare progetti personali per mettere alla prova idee e soluzioni nuove.",
      hobbies: ["Viaggi", "Libri", "Trekking e Triathlon"],
    },
    projects: {
      myRecent: "I Miei Recenti",
      works: "Progetti",
      subtitle: "Ecco alcuni progetti su cui ho lavorato di recente.",
      visit: "Visita",
      items: [
        {
          title: "GocciaGo",
          description:
            "App Mobile per Trova Fontane di Acqua Potabile Vicino a Te.",
        },
        {
          title: "QuotaReader",
          description:
            "QuotaReader estrae automaticamente tutte le quote da PDF vettoriali e le numera con balloon interattivi. Dalla quotatura al report FAI senza ricopiare nulla a mano.",
        },
        {
          title: "App Mobile - Supabase API",
          description:
            "Il progetto utilizza Supabase come backend-as-a-service per fornire funzionalità di autenticazione, database e API serverless.",
        },
        {
          title: "Fullstack Kafka Application",
          description:
            "Applicazione full-stack con React, Node.js, Kafka e Docker.",
        },
        {
          title: "DocuChat — Chatbot RAG Locale",
          description:
            "Chatta con i tuoi documenti PDF usando un'infrastruttura AI completamente locale. Nessun cloud, nessuna API key, nessun dato che lascia il tuo computer.",
        },
        {
          title: "Chatbot MVP PDF",
          description:
            "Chatbot basato su documenti PDF. Permette di caricare PDF, fare domande, e verifica le risposte con le fonti dei documenti originali. In questa prima versione la risposta all'utente non è generata da un LLM ma mockata con delle risposte di default.",
        },
      ],
    },
    resume: {
      download: "Scarica CV",
    },
    presentation: {
      title: "Video",
      titleHighlight: "Presentazione",
      subtitle: "Inserisci la password per guardare il video di presentazione.",
      placeholder: "Password",
      submit: "Sblocca",
      wrongPassword: "Password errata. Riprova.",
    },
  },
};
